import React from 'react'
import { useQuery } from '@apollo/client'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Typography from '@material-ui/core/Typography'
import BookingTypeDetailsDialog from 'pages/pga-coach/bookings/booking-types/booking-type-details-dialog'
import { GET_LESSON_TYPE_DETAILS } from 'pages/pga-coach/bookings/booking-types/queries'

// `query` lets a caller that shows Virtual Coaching offerings select their
// extra fields (`GET_LESSON_TYPE_DETAILS_WITH_VIRTUAL_COACHING`).
const LessonTypeDetails = ({
  lessonTypeId,
  onClose,
  query = GET_LESSON_TYPE_DETAILS,
}) => {
  const { data, loading, error } = useQuery(query, {
    variables: { id: lessonTypeId },
    skip: !lessonTypeId,
  })
  const lessonType = data?.lessonTypes?.[0]

  if (!lessonTypeId) return null

  if (lessonType) {
    return (
      <BookingTypeDetailsDialog
        isOpen
        setIsOpen={isOpen => {
          if (!isOpen) onClose()
        }}
        bookingType={lessonType}
      />
    )
  }

  return (
    <Dialog open onClose={onClose} maxWidth="xs" fullWidth>
      {loading ? (
        <DialogContent>
          <Box display="flex" justifyContent="center" p={2}>
            <CircularProgress aria-label="Loading lesson type details" />
          </Box>
        </DialogContent>
      ) : (
        <>
          <DialogTitle>Lesson type details</DialogTitle>
          <DialogContent>
            <Typography>
              {error
                ? 'We could not load this lesson type. Please try again.'
                : 'This lesson type could not be found.'}
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button color="primary" onClick={onClose}>
              Close
            </Button>
          </DialogActions>
        </>
      )}
    </Dialog>
  )
}

export default LessonTypeDetails
